import { Api } from "./api";
export let api: Api;
export function initializeApi(baseUrl: string) {
  if (!api) {
    api = new Api(baseUrl);
  }
  return api;
}
